export enum SseTypeEnum {
  FOLLOWUP_SUGGESTER = 'followup_suggester',
  NAVIGATION_SUGGESTER = 'navigation_suggester',
  TOPIC_SUGGESTER = 'topic_suggester',
  TOPIC_SUGGESTER_ORCHESTRATOR = 'orchestrator.topic_suggester.extract',
  WORKER = 'worker',
  WORKER_ORCHESTRATOR = 'orchestrator.worker.worker',
  EXECUTE_ACTIONS = 'execute_actions',
}

export enum ISSEventMessageType {
  ERROR = 'error',
  DATA = 'data',
  END = 'end',
}

export enum IChatMessageType {
  AI = 'ai',
  HUMAN = 'human',
}
